module.exports = __webpack_public_path__ + "static/img/5.aebddd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting809/images/5.png
// module id = dubo
// module chunks = 4